/**
 * @generated SignedSource<<2231bf12278fff5f7fce80dd6515b951>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4FiltersContent$data = {
  readonly jira: {
    readonly favouriteFilters: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename?: string;
          readonly filterId?: string;
          readonly id?: string;
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterMenuItem" | "Nav4FilterMenuItemRefactored">;
        };
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly recentFilters: {
      readonly __id: string;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly filterId?: string;
          readonly id?: string;
          readonly name?: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterMenuItem" | "Nav4FilterMenuItemRefactored">;
        };
      } | null> | null;
    };
    readonly systemFilters: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly filterId: string;
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"Nav4FilterMenuItem" | "Nav4FilterMenuItemRefactored">;
        };
      } | null> | null;
    };
  };
  readonly " $fragmentType": "Nav4FiltersContent";
};
export type Nav4FiltersContent$key = {
  readonly " $data"?: Nav4FiltersContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4FiltersContent">;
};

import Nav4FiltersContentQuery_graphql from './Nav4FiltersContentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "filterId"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "FragmentSpread",
  "name": "Nav4FilterMenuItem"
},
v5 = {
  "kind": "FragmentSpread",
  "name": "Nav4FilterMenuItemRefactored"
},
v6 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "currentURL"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "fragmentPathInResult": [],
      "operation": Nav4FiltersContentQuery_graphql
    }
  },
  "name": "Nav4FiltersContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "alias": "favouriteFilters",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Literal",
                  "name": "filter",
                  "value": {
                    "sort": {
                      "order": "DESC"
                    },
                    "type": "FILTER"
                  }
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 15
                }
              ],
              "concreteType": "JiraFavouriteConnection",
              "kind": "LinkedField",
              "name": "favourites",
              "plural": false,
              "selections": [
                {
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "hasNextPage"
                    }
                  ]
                },
                {
                  "concreteType": "JiraFavouriteEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v1/*: any*/),
                              (v2/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "type": "JiraFilter",
                            "abstractKey": "__isJiraFilter"
                          }
                        ]
                      },
                      "action": "THROW"
                    }
                  ]
                },
                (v6/*: any*/)
              ]
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "alias": "recentFilters",
              "args": [
                (v0/*: any*/),
                {
                  "kind": "Variable",
                  "name": "currentURL",
                  "variableName": "currentURL"
                },
                {
                  "kind": "Literal",
                  "name": "first",
                  "value": 20
                },
                {
                  "kind": "Literal",
                  "name": "types",
                  "value": [
                    "FILTER"
                  ]
                }
              ],
              "concreteType": "JiraSearchableEntityConnection",
              "kind": "LinkedField",
              "name": "recentItems",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSearchableEntityEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v2/*: any*/),
                              (v1/*: any*/),
                              (v3/*: any*/),
                              (v4/*: any*/),
                              (v5/*: any*/)
                            ],
                            "type": "JiraCustomFilter"
                          }
                        ]
                      },
                      "action": "THROW"
                    }
                  ]
                },
                (v6/*: any*/)
              ]
            },
            "action": "THROW"
          },
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                (v0/*: any*/)
              ],
              "concreteType": "JiraSystemFilterConnection",
              "kind": "LinkedField",
              "name": "systemFilters",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraSystemFilterEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "concreteType": "JiraSystemFilter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v2/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      "action": "THROW"
                    }
                  ]
                }
              ]
            },
            "action": "THROW"
          }
        ]
      },
      "action": "THROW"
    }
  ],
  "type": "Query"
};
})();

(node as any).hash = "3f2c652ff4b3b6620f4d64beb5fb3443";

export default node;
